import L from "leaflet";

const CROSSHAIR_HTML = `
  <div class="user-location-crosshair" aria-hidden="true">
    <span class="user-location-backdrop"></span>
    <span class="user-location-arm user-location-arm-n"></span>
    <span class="user-location-arm user-location-arm-e"></span>
    <span class="user-location-arm user-location-arm-s"></span>
    <span class="user-location-arm user-location-arm-w"></span>
    <span class="user-location-dot"></span>
  </div>
`;

function buildUserLocationIcon(pulsing, pulseStrength = "normal") {
  let pulseRingClass = "pulse-ring";
  if (pulseStrength === "subtle") pulseRingClass = "pulse-ring pulse-ring--subtle";
  if (pulseStrength === "desktop") pulseRingClass = "pulse-ring pulse-ring--desktop-mid";
  if (pulseStrength === "mobile") pulseRingClass = "pulse-ring pulse-ring--mobile";

  const html = pulsing
    ? `<div class="pulse-container user-location-marker"><div class="${pulseRingClass}"></div>${CROSSHAIR_HTML}</div>`
    : `<div class="user-location-marker user-location-marker-static">${CROSSHAIR_HTML}</div>`;

  return L.divIcon({
    className: pulsing
      ? "user-location-div-icon user-location-div-icon--pulse"
      : "user-location-div-icon",
    html,
    iconSize: [48, 48],
    iconAnchor: [24, 24],
  });
}

let cachedStaticIcon = null;
let cachedPulsingIcon = null;
let cachedSubtlePulsingIcon = null;
let cachedDesktopPulsingIcon = null;

let cachedMobilePulsingIcon = null;

/** Crosshair "my location" marker — distinct from solid lead pins. */
export function createUserLocationIcon({ pulsing = false, subtle = false, pulseStrength } = {}) {
  const strength = pulseStrength || (subtle ? "subtle" : "normal");
  if (pulsing && strength === "mobile") {
    if (!cachedMobilePulsingIcon) {
      cachedMobilePulsingIcon = buildUserLocationIcon(true, "mobile");
    }
    return cachedMobilePulsingIcon;
  }
  if (pulsing && strength === "desktop") {
    if (!cachedDesktopPulsingIcon) {
      cachedDesktopPulsingIcon = buildUserLocationIcon(true, "desktop");
    }
    return cachedDesktopPulsingIcon;
  }
  if (pulsing && strength === "subtle") {
    if (!cachedSubtlePulsingIcon) cachedSubtlePulsingIcon = buildUserLocationIcon(true, "subtle");
    return cachedSubtlePulsingIcon;
  }
  if (pulsing) {
    if (!cachedPulsingIcon) cachedPulsingIcon = buildUserLocationIcon(true, "normal");
    return cachedPulsingIcon;
  }
  if (!cachedStaticIcon) cachedStaticIcon = buildUserLocationIcon(false);
  return cachedStaticIcon;
}

/** Mobile map: pulsing crosshair variant. */
export function createPulsingLocationIcon() {
  return createUserLocationIcon({ pulsing: true, pulseStrength: "mobile" });
}
